import { useMutation } from "@tanstack/react-query";
import Api from "src/Config";
import { createContext, FunctionComponent, ReactElement, useMemo } from "react";

export const DataFrequencyContext = createContext(null);

type Props = {
  children: ReactElement;
};

const DataFrequencyProvider: FunctionComponent<Props> = ({ children }) => {
  const { mutateAsync, data, isPending, error } = useMutation({
    mutationFn: async (payload) => {
      const data = await Api.put(`settings/tm/processing-frequency`, payload);
      return data;
    },
    onError: (err) => {
      console.log(err, "###");
    },
  });

  const contextValue = useMemo(
    () => ({
      mutateAsync,
      data,
      isPending,
      error,
    }),
    [mutateAsync, data, isPending, error],
  );
  return (
    <DataFrequencyContext.Provider value={contextValue}>
      {children}
    </DataFrequencyContext.Provider>
  );
};

export default DataFrequencyProvider;
